export const shouldDisplayFreeText = (price: string | undefined) => {
    return price === 'Free' || price === '0' || price === '0.0005' || price === '$0.00'
}
